import { AccessType } from '@interface/common';

export const AUTHENTICATED: AccessType = 'authenticated';
export const UNAUTHENTICATED: AccessType = 'unauthenticated';
